// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "html:root{--color: red}", "",{"version":3,"sources":["webpack://src/theme/Theme2/Theme2.module.scss"],"names":[],"mappings":"AAAA,UACE,YAAA","sourcesContent":["html:root {\n  --color: red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
